import { numericFormatter } from 'react-number-format';
import { columns } from '../../../dtos/columns';
import { GenerarDivRow } from '../models/dividendos';


export function useColumns() {
    const COLUMNS: columns<GenerarDivRow>[] = [
        {
            name: 'Día',
            selector: (row) =>
                row.dia,
            sortable: true,
            sortField: 'dia',
            wrap: true,
            export: true
        },
        {
            name: 'Pago Mínimo ($)',
            selector: (row) =>
                row.pagoMinimo,
            cell: (row: GenerarDivRow) => numericFormatter(row.pagoMinimo.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "$ " }),
            sortable: true,
            sortField: 'pagoMinimo',
            wrap: true,
            export: true
        },
        {
            name: 'Pago máximo ($)',
            selector: (row) =>
                row.pagoMaximo,
            cell: (row: GenerarDivRow) => numericFormatter(row.pagoMaximo.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "$ " }),

            sortable: true,
            sortField: 'pagoMaximo',
            wrap: true,
            export: true
        },
    ];

    return { COLUMNS };
}